import React, { useState, useEffect } from 'react';
import { HEADER, HEADER_ICON, DEFAULT_STEP, DEFAULT_NUMBER, DATA_GET, EMPTY } from './constants.jsx';
import CalculatorHeader from './components/Global/Header/index.tsx';
import CalculatorRevenue from './components/Revenue_Generator/index.tsx';
import { toFloat, removeSpecialChars, removeNonNumeric } from './helper.ts'
import './App.scss';
import Summary from './components/Summary/index.tsx';

const Calculator = () => {
  const [step, setStep] = useState(DEFAULT_STEP.MIN);
  const [valuesStep1, setValuesStep1] = useState({ "returns": EMPTY, "paidreturns": EMPTY, "paidfee": EMPTY, "resalevalue": EMPTY });
  const [valuesStep2, setValuesStep2] = useState({ "reduction": EMPTY, "costs": EMPTY });
  const [result, setResult] = useState({ "step1": DEFAULT_NUMBER, "step2": DEFAULT_NUMBER, "step3": DEFAULT_NUMBER, "step4": DEFAULT_NUMBER });

  useEffect(() => {
    getFullResult1()
  }, [valuesStep1,valuesStep2])

  const inputHandlerStep1 = (e) => {
    const { name, value } = e.target;
    setValuesStep1({ ...valuesStep1, [name]: removeNonNumeric(value) });
  };

  const inputHandlerStep2 = (e) => {
    const { name, value } = e.target;
    setValuesStep2({ ...valuesStep2, [name]: removeNonNumeric(value) });
  };

  const getFullResult1 = () => {
    const step1Results = (parseFloat(valuesStep1.returns) * parseFloat(valuesStep1.paidreturns) * parseFloat(valuesStep1.paidfee)) / 100
    const percentageofRevenue = toFloat(step1Results) * parseFloat(valuesStep1.resalevalue) / 100
    setResult(prevState => ({
      ...prevState,
      "step1": toFloat(step1Results),
      "step2": toFloat(percentageofRevenue)
    }));
  };

  const clickHandler = (e) => {
    const newStep = parseInt (e.target.getAttribute(DATA_GET));
    switch (step) {
      case 1:
        if ((valuesStep1.returns > 0 && valuesStep1.paidreturns > 0) || step > newStep) return setStep(newStep);
        break;
      case 2:
        if ((valuesStep2.reduction >= 100 && valuesStep2.reduction <= 150) || step > newStep) return setStep(newStep);
        break;
      case 6:
        setStep(parseInt(e.target.getAttribute(DATA_GET)));
        break;
      default:
        return null;
    }
  }

  const renderStepComponent = () => {
    switch (step) {
      case 1:
        return <CalculatorRevenue inputHandler={inputHandlerStep1} clickHandler={clickHandler} step={step} values={valuesStep1} step1Result={result.step1} />;
      case 2:
        return <Summary inputHandler={inputHandlerStep2} clickHandler={clickHandler} step={step} step2Result={result.step2} step1Result={result.step1}/>;
      default:
        return <CalculatorRevenue inputHandler={inputHandlerStep1} clickHandler={clickHandler} step={step} values={valuesStep1} />;
    }
  };

  return (
    <div className="calculator">
      <CalculatorHeader header={HEADER} logo={HEADER_ICON} />
      <div className="calculator__inner">
        <div className="calculator__content">
          {renderStepComponent()}
        </div>
      </div>
    </div>
  );
};

export default Calculator;